<div class="padding-24 pos-r" *ngIf="loading">
  <app-loader></app-loader>
</div>
<div class="grid grid--gap-32">
  <div class="grid__box grid__box--size-min">
    <div class="grid" style="width: 445px">
      <div class="grid__box grid__box--size-min">
        <span class="title title--s"> BeeKeeper </span>
      </div>
      <div class="grid__box grid__box--size-min grid__box--pull-right" (click)="isShowChangedNameTickets = !isShowChangedNameTickets">
        <a class="link link--dotted-blue-dark" *ngIf="!isShowChangedNameTickets">Показать с измененным названием</a>
        <a class="link link--dotted-blue-dark" *ngIf="isShowChangedNameTickets">Показать все</a>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box">
        <app-field>
          <content-prefix>
            <div class="field__input-prefix">
              <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </content-prefix>
          <input type="text" class="input-text input--prefix" id="typesBKSearchText" [(ngModel)]="typesBKSearchText" placeholder="Поиск по типам заявок в ВК" />
        </app-field>
      </div>
    </div>
    <div class="mt-16 ticket-types__list">
      <div
        class="list__item"
        *ngFor="let type of bkTicketsTypes | searchTextFilter: typesBKSearchText : 'name' | showDuplicateTicketsTypes: hdTicketsTypes : isShowChangedNameTickets; let index = index"
      >
        <div class="grid">
          <div class="grid__box grid__box--size-2 ta-right">
            {{ type.id }}
          </div>
          <div class="grid__box grid__box--size-9">
            <ng-container *ngTemplateOutlet="checkMissingBK(type) || checkNotMatchName(type) ? template1 : template2; context: { type: type }"></ng-container>
          </div>
          <div class="grid__box grid__box--size-1">
            <span class="item__remove-ctrl" (click)="removeTypeToBK(type, index)">
              <app-icon [glyph]="'hd-close-small'" [size]="'22'" [class]="'cur-pointer'" [color]="'gray-dark'"></app-icon>
            </span>
          </div>
        </div>
      </div>
      <div
        class="mt-4 ta-center"
        *ngIf="!(bkTicketsTypes | searchTextFilter: typesBKSearchText : 'name' | showDuplicateTicketsTypes: hdTicketsTypes : isShowChangedNameTickets).length"
      >
        Ничего не найдено.
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--size-min">
    <div class="grid" style="width: 445px">
      <div class="grid__box grid__box--size-min">
        <span class="title title--s"> HelpDesk </span>
      </div>
      <div class="grid__box grid__box--size-min grid__box--pull-right" (click)="isShowMissingTickets = !isShowMissingTickets">
        <a class="link link--dotted-blue-dark" *ngIf="!isShowMissingTickets">Показать отсутствующие в BK</a>
        <a class="link link--dotted-blue-dark" *ngIf="isShowMissingTickets">Показать все</a>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box">
        <app-field>
          <content-prefix>
            <div class="field__input-prefix">
              <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </content-prefix>
          <input type="text" class="input-text input--prefix" id="typesHDSearchText" [(ngModel)]="typesHDSearchText" placeholder="Поиск по типам заявок в ВК" />
        </app-field>
      </div>
    </div>
    <div class="mt-16 ticket-types__list">
      <div
        class="list__item"
        *ngFor="
          let type of hdTicketsTypes
            | searchTextFilter: typesHDSearchText : 'name'
            | showDuplicateTicketsTypes: bkTicketsTypes : isShowChangedNameTickets
            | showMissingTicketsTypes: bkTicketsTypes : isShowMissingTickets;
          let index = index
        "
      >
        <div class="grid">
          <div class="grid__box grid__box--size-2 ta-right pos-r">
            <div class="list__add-ctrl" *ngIf="checkShowAdd(type)" (click)="addTypeToBK(type, index)">
              <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'gray-dark'"></app-icon>
            </div>
            {{ type.id }}
          </div>
          <div class="grid__box grid__box--size-9">
            <ng-container *ngTemplateOutlet="checkMissingBK(type) || checkNotMatchName(type) ? template1 : template2; context: { type: type }"></ng-container>
          </div>
        </div>
      </div>
      <div
        class="mt-4 ta-center"
        *ngIf="
          !(
            hdTicketsTypes
            | searchTextFilter: typesHDSearchText : 'name'
            | showDuplicateTicketsTypes: bkTicketsTypes : isShowChangedNameTickets
            | showMissingTicketsTypes: bkTicketsTypes : isShowMissingTickets
          ).length
        "
      >
        Ничего не найдено.
      </div>
    </div>
  </div>
</div>

<div *ngIf="isErrorSave" class="mt-16">
  <app-message [type]="'error'">
    <div message-content>
      {{ Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']] }}
    </div>
  </app-message>
</div>

<div class="mt-32">
  <div class="grid grid--va-middle">
    <div class="grid__box grid__box--size-min">
      <button type="button" class="button" (click)="onSaveTypes()">Сохранить</button>
    </div>
    <div class="grid__box grid__box--size-min">
      <a class="link link--dotted-blue-dark" (click)="resetTypes()">Сбросить</a>
    </div>
  </div>
</div>

<ng-template #template1 let-type="type">
  <div class="cur-help" ngbPopover="{{ missingPlaceholder }}" triggers="mouseenter:mouseleave" placement="bottom-left" openDelay="350">
    <span [ngClass]="{ 'color-gray': checkNotMatchName(type) }">{{ type.name }}</span>
  </div>
</ng-template>

<ng-template #template2 let-type="type">
  {{ type.name }}
</ng-template>
